import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useApp from '@/pages/App.context';
import OnboardingProgress from './OnboardingProgress';
import DashboardStats from './DashboardStats';
import AwaitingSignatures from './AwaitingSignatures';
import NeedsAttention from './NeedsAttention';
import RecentActivity from './RecentActivity';
import StartSomethingNew from './StartSomethingNew';
import styles from './Dashboard.module.scss';

const Dashboard = () => {
  const { t } = useTranslation(['common']);
  const { setAppTitle, setHeadline } = useApp();

  useEffect(() => {
    setAppTitle(t('common:menu.dashboard'));
    setHeadline({
      title: t('common:dashboard.welcome.title'),
      subtitle: t('common:dashboard.welcome.subtitle'),
    });
  }, [setAppTitle, setHeadline, t]);

  return (
    <div className={styles.pane}>
      <OnboardingProgress />
      <DashboardStats />
      <AwaitingSignatures />
      <StartSomethingNew />
      <NeedsAttention />
      <RecentActivity />
    </div>
  );
};

export default Dashboard;
